import { GET_CUSTOMISE_TABLE, GET_ALL_CUSTOMISETABLES } from '../types'

const INITIAL_STATE = {
  customiseData: [],
  allCustomisetable: [],
}

const customiseTableReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_CUSTOMISE_TABLE:
      return {
        ...state,
        customiseData: payload.data,
      }
    case GET_ALL_CUSTOMISETABLES:
      return {
        ...state,
        allCustomisetable: payload.data,
      }
    default:
      return state
  }
}

export default customiseTableReducer
